/**
 * Picking what a Trainer or a Pokémon Power works on, one step at a time, as the server's steps say: a Pokémon on
 * the board (and maybe its energy cards), cards from your hand or discard pile, or an energy type.
 */
export const START_PICKS = 'PICKS/START_PICKS';
/** A Pokémon is tapped whose energy cards are picked next, in the menu. */
export const CHOOSE_PICK_ENERGY = 'PICKS/CHOOSE_PICK_ENERGY';
/** One step's pick is made. */
export const PICK_STEP = 'PICKS/PICK_STEP';
/** Every step is picked (or there were none): the Trainer is played or the Power used. */
export const SUBMIT_PICKS = 'PICKS/SUBMIT_PICKS';
export const PICKS_CANCEL = 'PICKS/PICKS_CANCEL';
export const END_PICKS = 'PICKS/END_PICKS';

/** What the picks are for. */
export const TRAINER = 'trainer';
export const POWER = 'power';

/** Where a step picks from, as the server names them. */
export const PLAYER = 'player';
export const OPPONENT = 'opponent';
export const HAND = 'hand';
export const DISCARD = 'discard';
export const OPPONENT_DISCARD = 'opponent_discard';
export const TYPE = 'type';

/** A step that picks a Pokémon on the board, rather than in the menu. */
export const picksPokemon = (step) => !!step && [PLAYER, OPPONENT].includes(step.get('from'));
